var _rect, _rect2, _line, _line2, _circle, _circle2, _circle3, _path, _path2, _circle4, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect10, _rect11, _path32, _path33, _path34, _path35, _circle12, _circle13, _path36, _rect12, _path37, _line3, _path38, _path39, _line4, _line5, _path40, _path41, _path42, _path43, _circle14, _line6, _path44, _path45, _path46, _rect13, _rect14, _path47, _path48, _path49, _path50, _circle15, _circle16, _path51, _rect15, _path52, _line7, _path53, _path54, _line8, _line9, _path55, _path56, _path57, _path58, _circle17, _line10, _rect16, _rect17, _path59, _path60, _line11, _line12, _path61, _circle18, _circle19, _g, _rect18, _rect19, _rect20, _g2, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _rect21, _rect22, _path76, _path77, _path78, _path79, _circle20, _circle21, _path80, _rect23, _path81, _line13, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _line14, _line15, _path100, _path101, _path102, _path103, _circle22, _line16, _circle23, _circle24, _g3, _line17, _line18, _rect24, _line19, _rect25, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlauUkulele(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 706,
    viewBox: "0 0 557 706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.47656,
    y: 9,
    width: 534,
    height: 393.28,
    rx: 19,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47656,
    y: 1,
    width: 534,
    height: 393.28,
    rx: 19,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 33.4436,
    x2: 535.156,
    y2: 33.4436,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 345.477,
    y1: 34,
    x2: 345.477,
    y2: 394,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.332,
    cy: 18.0664,
    r: 3.38476,
    fill: "#FFC900"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7266,
    cy: 18.0664,
    r: 3.38476,
    fill: "#E2442F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4863,
    cy: 18.0664,
    r: 3.38476,
    fill: "#23A094"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4766 343H29.4766C27.8197 343 26.4766 344.343 26.4766 346V362C26.4766 363.657 27.8197 365 29.4766 365H63.4766C65.1334 365 66.4766 363.657 66.4766 362V346C66.4766 344.343 65.1334 343 63.4766 343Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.477 343H80.4766C78.8197 343 77.4766 344.343 77.4766 346V362C77.4766 363.657 78.8197 365 80.4766 365H114.477C116.133 365 117.477 363.657 117.477 362V346C117.477 344.343 116.133 343 114.477 343Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.936,
    cy: 354.46,
    r: 10.4596,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.935 349.319V359.6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.795 354.459H150.076",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 223.19,
    width: 59.338,
    height: 6,
    rx: 3,
    fill: "#D6D3D1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 241,
    width: 45.3011,
    height: 5.74239,
    rx: 2.87119,
    fill: "#D6D3D1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 259,
    width: 74.013,
    height: 5.10434,
    rx: 2.55217,
    fill: "#D6D3D1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 276,
    width: 59.338,
    height: 5.74239,
    rx: 2.87119,
    fill: "#D6D3D1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 294,
    width: 85.4978,
    height: 5.74239,
    rx: 2.87119,
    fill: "#D6D3D1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 312,
    width: 65.0804,
    height: 5.74239,
    rx: 2.87119,
    fill: "#D6D3D1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 404.703,
    y: 330,
    width: 45.3011,
    height: 5.74239,
    rx: 2.87119,
    fill: "#D6D3D1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 225.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 243.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 261.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 279.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 297.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 315.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.219,
    cy: 333.742,
    r: 5.74239,
    fill: "#FFC900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4289 71V59.8H38.1489L35.0289 69.64L31.9089 59.8H28.6289V71H30.3889V60.776L33.6689 71H36.3889L39.6689 60.776V71H41.4289Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0183 63.416L46.8103 68.056L44.7463 63.416H42.9383L45.9303 69.88L43.8983 74.168H45.6583L50.7783 63.416H49.0183Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2027 66.52H61.6427C63.9627 66.52 65.2427 64.904 65.2427 63.16C65.2427 61.352 63.9787 59.8 61.6427 59.8H56.4427V71H58.2027V66.52ZM58.2027 64.84V61.48H61.4827C62.6187 61.48 63.4027 62.136 63.4027 63.16C63.4027 64.184 62.6187 64.84 61.4827 64.84H58.2027Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0234 63.416V71H68.7034V65.96C68.7034 65.176 69.1834 64.696 69.9034 64.696C70.5434 64.696 71.0234 65.128 71.0234 65.72C71.0234 65.928 71.0074 66.152 70.9594 66.36H72.6234C72.7034 66.056 72.7354 65.736 72.7354 65.4C72.7354 64.792 72.5274 64.28 72.1114 63.88C71.6954 63.464 71.1674 63.256 70.5434 63.256C69.6474 63.256 69.0074 63.704 68.7034 64.52V63.416H67.0234Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9873 67.208C73.9873 69.448 75.6033 71.16 77.8913 71.16C80.1793 71.16 81.7953 69.448 81.7953 67.208C81.7953 64.968 80.1793 63.256 77.8913 63.256C75.6033 63.256 73.9873 64.968 73.9873 67.208ZM80.1153 67.208C80.1153 68.632 79.1713 69.64 77.8913 69.64C76.6113 69.64 75.6673 68.632 75.6673 67.208C75.6673 65.784 76.6113 64.776 77.8913 64.776C79.1713 64.776 80.1153 65.784 80.1153 67.208Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1804 67.256C83.1804 69.512 84.5724 71.16 86.7004 71.16C87.8364 71.16 88.7804 70.632 89.2444 69.72V71H90.8604V59.8H89.1804V64.76C88.7484 63.848 87.8684 63.256 86.7004 63.256C84.5724 63.256 83.1804 64.936 83.1804 67.256ZM89.2444 67.256C89.2444 68.744 88.2044 69.672 87.0524 69.672C86.4284 69.672 85.9164 69.448 85.4844 69.016C85.0684 68.568 84.8604 67.976 84.8604 67.256C84.8604 65.8 85.8524 64.776 87.0524 64.776C88.2044 64.776 89.2444 65.768 89.2444 67.256Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2697 63.416V67.4C98.2697 68.824 97.4857 69.72 96.3497 69.72C95.3897 69.72 94.8297 69.08 94.8297 67.88V63.416H93.1497V68.28C93.1497 70.2 94.2537 71.16 95.9177 71.16C96.9417 71.16 97.7257 70.712 98.2697 69.8V71H99.9497V63.416H98.2697Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.785 69.72C104.569 69.72 103.385 68.712 103.385 67.16C103.385 65.56 104.521 64.696 105.625 64.696C106.729 64.696 107.529 65.384 107.705 66.52L109.225 66.04C108.905 64.312 107.497 63.256 105.625 63.256C103.529 63.256 101.785 64.872 101.785 67.16C101.785 69.56 103.401 71.16 105.865 71.16C107.769 71.16 109.241 70.056 109.625 68.12L108.105 67.56C107.929 68.824 107.193 69.72 105.785 69.72Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.008 68.6C112.008 70.184 112.936 71.16 114.728 71.16C116.184 71.16 117.144 70.28 117.288 68.76L115.688 68.44C115.624 69.32 115.288 69.72 114.648 69.72C114.12 69.72 113.688 69.368 113.688 68.68V64.856H116.568V63.416H113.688V61H112.008V63.416H110.488V64.856H112.008V68.6Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5469 105.91V115H47.3069V94H44.5469V103.39H32.5169V94H29.7569V115H32.5169V105.91H44.5469Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.886 107.89C50.886 112.09 53.796 115.3 58.086 115.3C62.346 115.3 65.316 112.09 65.316 107.89C65.316 103.69 62.406 100.48 58.086 100.48C53.796 100.48 50.886 103.69 50.886 107.89ZM62.646 107.89C62.646 110.89 60.756 112.96 58.086 112.96C55.446 112.96 53.526 110.86 53.526 107.89C53.526 104.92 55.446 102.82 58.086 102.82C59.436 102.82 60.516 103.3 61.356 104.26C62.226 105.19 62.646 106.42 62.646 107.89Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3623 100.78H66.8123L71.0423 115H74.2823L77.4323 104.08L80.5823 115H83.7923L88.0223 100.78H85.4723L82.1423 112.48L78.9323 100.78H75.9023L72.6923 112.48L69.3623 100.78Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7021 110.77C99.7021 113.62 101.352 115.3 104.352 115.3C106.782 115.3 108.402 113.89 108.792 111.34L106.392 110.8C106.152 112.36 105.462 113.02 104.262 113.02C103.152 113.02 102.312 112.24 102.312 110.89V102.97H107.412V100.78H102.312V96.37H99.7021V100.78H96.8821V102.97H99.7021V110.77Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.285 107.89C110.285 112.09 113.195 115.3 117.485 115.3C121.745 115.3 124.715 112.09 124.715 107.89C124.715 103.69 121.805 100.48 117.485 100.48C113.195 100.48 110.285 103.69 110.285 107.89ZM122.045 107.89C122.045 110.89 120.155 112.96 117.485 112.96C114.845 112.96 112.925 110.86 112.925 107.89C112.925 104.92 114.845 102.82 117.485 102.82C118.835 102.82 119.915 103.3 120.755 104.26C121.625 105.19 122.045 106.42 122.045 107.89Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M138.508 106.36H145.018C149.248 106.36 151.828 103.51 151.828 100.18C151.828 96.76 149.368 94 145.018 94H135.748V115H138.508V106.36ZM138.508 103.75V96.61H144.778C147.268 96.61 148.918 97.9 148.918 100.18C148.918 102.46 147.268 103.75 144.778 103.75H138.508Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.374 115H157.954V94H155.374V115Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.456 110.95C161.456 112.27 161.906 113.32 162.806 114.13C163.736 114.91 164.846 115.3 166.166 115.3C168.446 115.3 170.336 114.28 171.056 112.75V115H173.546V106.09C173.546 102.58 171.356 100.48 167.486 100.48C164.156 100.48 161.936 102.22 161.366 104.95L163.706 105.61C164.066 103.78 165.446 102.67 167.486 102.67C169.616 102.67 171.056 103.81 171.056 105.88V107.35L169.766 106.99C168.806 106.69 167.786 106.54 166.736 106.54C163.646 106.54 161.456 108.04 161.456 110.95ZM171.056 109.69C171.056 111.76 169.406 113.02 167.036 113.02C165.146 113.02 164.126 112.12 164.126 110.8C164.126 109.33 165.266 108.55 167.096 108.55C167.846 108.55 168.746 108.7 169.736 109L171.056 109.39V109.69Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.39 100.78L182.16 110.14L178.17 100.78H175.35L180.78 113.17L177.27 120.94H180.03L189.15 100.78H186.39Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M199.277 94V106.6C199.277 111.67 202.577 115.3 207.917 115.3C213.257 115.3 216.587 111.67 216.587 106.6V94H213.827V106.33C213.827 110.38 211.607 112.69 207.917 112.69C204.287 112.69 202.037 110.38 202.037 106.33V94H199.277Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M227.382 106.54L232.782 100.78H229.482L223.392 107.44V94H220.812V115H223.392V110.77L225.582 108.46L230.082 115H233.232L227.382 106.54Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M245.727 109.84C245.157 111.88 243.807 113.02 241.617 113.02C239.097 113.02 237.117 111.37 237.087 108.28H247.377C247.497 107.74 247.557 107.17 247.557 106.54C247.557 104.68 246.987 103.21 245.817 102.13C244.647 101.02 243.117 100.48 241.227 100.48C237.177 100.48 234.447 103.72 234.447 107.8C234.447 112.39 237.447 115.3 241.617 115.3C244.887 115.3 247.017 113.59 247.977 110.71L245.727 109.84ZM237.087 106.42C237.357 104.17 239.007 102.76 241.197 102.76C243.357 102.76 245.007 103.96 245.007 106L244.977 106.42H237.087Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M251.141 115H253.721V94H251.141V115Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.293 109.84C267.723 111.88 266.373 113.02 264.183 113.02C261.663 113.02 259.683 111.37 259.653 108.28H269.943C270.063 107.74 270.123 107.17 270.123 106.54C270.123 104.68 269.553 103.21 268.383 102.13C267.213 101.02 265.683 100.48 263.793 100.48C259.743 100.48 257.013 103.72 257.013 107.8C257.013 112.39 260.013 115.3 264.183 115.3C267.453 115.3 269.583 113.59 270.543 110.71L268.293 109.84ZM259.653 106.42C259.923 104.17 261.573 102.76 263.763 102.76C265.923 102.76 267.573 103.96 267.573 106L267.543 106.42H259.653Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.707 115H276.287V94H273.707V115Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M290.859 109.84C290.289 111.88 288.939 113.02 286.749 113.02C284.229 113.02 282.249 111.37 282.219 108.28H292.509C292.629 107.74 292.689 107.17 292.689 106.54C292.689 104.68 292.119 103.21 290.949 102.13C289.779 101.02 288.249 100.48 286.359 100.48C282.309 100.48 279.579 103.72 279.579 107.8C279.579 112.39 282.579 115.3 286.749 115.3C290.019 115.3 292.149 113.59 293.109 110.71L290.859 109.84ZM282.219 106.42C282.489 104.17 284.139 102.76 286.329 102.76C288.489 102.76 290.139 103.96 290.139 106L290.109 106.42H282.219Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M311.901 149H33C29.6863 149 27 151.686 27 155V313.602C27 316.916 29.6863 319.602 33 319.602H311.901C315.215 319.602 317.901 316.916 317.901 313.602V155C317.901 151.686 315.215 149 311.901 149Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2939 263.984C57.2939 257.909 62.2188 252.984 68.2939 252.984H98.8263C104.901 252.984 109.826 257.909 109.826 263.984V319.658H57.2939V263.984Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2939,
    y: 306.212,
    width: 7.70963,
    height: 13.442,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 102.117,
    y: 306.212,
    width: 7.70963,
    height: 13.442,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7373 304.179L63.7373 305.179L65.7373 305.179L65.7373 304.179L63.7373 304.179ZM65.7373 273.113C65.7373 272.561 65.2896 272.113 64.7373 272.113C64.185 272.113 63.7373 272.561 63.7373 273.113L65.7373 273.113ZM65.7373 304.179L65.7373 273.113L63.7373 273.113L63.7373 304.179L65.7373 304.179Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M103.388 273.085C103.388 272.533 102.94 272.085 102.388 272.085C101.835 272.085 101.388 272.533 101.388 273.085L103.388 273.085ZM101.388 304.151L101.388 305.151L103.388 305.151L103.388 304.151L101.388 304.151ZM101.388 273.085L101.388 304.151L103.388 304.151L103.388 273.085L101.388 273.085Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.77 257.079C91.77 260.887 88.2197 264.184 83.5647 264.184C78.9097 264.184 75.3594 260.887 75.3594 257.079C75.3594 253.27 78.9097 249.973 83.5647 249.973C88.2197 249.973 91.77 253.27 91.77 257.079Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.126 184.644C116.126 190.728 112.925 196.338 107.543 200.586L107.543 200.586C102.381 204.651 102.383 213.079 107.543 217.149C112.925 221.397 116.126 227.007 116.126 233.091C116.126 239.486 112.589 245.359 106.703 249.671C100.817 253.983 92.6385 256.68 83.5628 256.68C74.4872 256.68 66.3086 253.983 60.4231 249.671C54.5368 245.359 51 239.486 51 233.091C51 227.007 54.2005 221.398 59.5817 217.15C64.7444 213.085 64.7434 204.656 59.5823 200.586C54.2008 196.338 51 190.728 51 184.644C51 178.25 54.5368 172.376 60.4231 168.064C66.3086 163.752 74.4872 161.055 83.5628 161.055C92.6385 161.055 100.817 163.752 106.703 168.064C112.589 172.376 116.126 178.25 116.126 184.644Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.4408,
    cy: 235.338,
    r: 1.80013,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 1.80171,
    transform: "matrix(-1 0 0 1 97.67 235.339)",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8906 241.917C77.3638 242.863 79.2187 244.87 82.8527 245.324C86.4867 245.778 89.2879 243.242 90.2342 241.917",
    stroke: "black",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 242.431,
    y: 194.157,
    width: 24.4461,
    height: 51.4654,
    rx: 12.223,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M273.312 232.755C273.312 243.058 264.96 251.411 254.656 251.411C244.353 251.411 236 243.058 236 232.755",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 254.384,
    y1: 251.411,
    x2: 254.384,
    y2: 319.602,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242.431 216.884H267.198",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M242.431 223.747H267.198",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 119.666,
    y1: 248.16,
    x2: 132.548,
    y2: 264.341,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 116.416,
    y1: 252.168,
    x2: 127.918,
    y2: 266.616,
    stroke: "black",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5148 298.816C96.2569 298.499 98.9466 297.435 101.265 295.589C107.873 290.328 108.965 280.707 103.705 274.099C98.4441 267.492 88.8228 266.399 82.215 271.66C79.8974 273.505 78.2582 275.887 77.3338 278.487C71.7023 277.355 65.6283 278.623 60.7826 282.48C52.0658 289.42 50.6251 302.112 57.5647 310.829C64.5043 319.545 77.1963 320.986 85.9131 314.047C90.7574 310.19 93.3545 304.557 93.5148 298.816Z",
    fill: "#FF90E8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5148 298.816L93.3997 297.823L92.5393 297.923L92.5152 298.788L93.5148 298.816ZM77.3338 278.487L77.1367 279.467L77.9859 279.638L78.276 278.822L77.3338 278.487ZM100.642 294.807C98.4742 296.533 95.9616 297.526 93.3997 297.823L93.6298 299.81C96.5522 299.471 99.4191 298.337 101.888 296.371L100.642 294.807ZM102.922 274.722C107.839 280.898 106.818 289.89 100.642 294.807L101.888 296.371C108.928 290.767 110.092 280.516 104.487 273.477L102.922 274.722ZM82.8379 272.442C89.0136 267.526 98.0057 268.546 102.922 274.722L104.487 273.477C98.8824 266.437 88.6321 265.273 81.5922 270.878L82.8379 272.442ZM78.276 278.822C79.1397 276.393 80.6705 274.168 82.8379 272.442L81.5922 270.878C79.1242 272.843 77.3768 275.381 76.3916 278.152L78.276 278.822ZM61.4054 283.263C66.0107 279.596 71.782 278.391 77.1367 279.467L77.5309 277.506C71.6227 276.319 65.2458 277.649 60.1598 281.698L61.4054 283.263ZM58.347 310.206C51.7514 301.921 53.1207 289.858 61.4054 283.263L60.1598 281.698C51.0109 288.982 49.4988 302.303 56.7823 311.452L58.347 310.206ZM85.2902 313.264C77.0055 319.86 64.9426 318.491 58.347 310.206L56.7823 311.452C64.0659 320.6 77.387 322.113 86.5359 314.829L85.2902 313.264ZM92.5152 298.788C92.3627 304.247 89.8942 309.599 85.2902 313.264L86.5359 314.829C91.6206 310.781 94.3462 304.867 94.5144 298.844L92.5152 298.788Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M116.704 259.338L120.996 264.73L93.1124 288.501L87.2875 281.185L116.704 259.338Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M120.994 264.737L116.701 259.345L125.35 248.923L133.09 258.645L120.994 264.737Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5617,
    cy: 284.561,
    r: 5.56442,
    transform: "rotate(51.4761 90.5617 284.561)",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 67.3322,
    y1: 293.678,
    x2: 76.4672,
    y2: 305.152,
    stroke: "black",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M370.477 64C370.477 60.6863 373.163 58 376.477 58H502.477C505.79 58 508.477 60.6863 508.477 64V149H370.477V64Z",
    fill: "#23A094"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M502.768 58H376.477C373.163 58 370.477 60.6863 370.477 64V360C370.477 363.314 373.163 366 376.477 366H502.768C506.082 366 508.768 363.314 508.768 360V64C508.768 60.6863 506.082 58 502.768 58Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M385.255 125.102C385.255 118.889 390.292 113.852 396.505 113.852H400.972C407.185 113.852 412.222 118.889 412.222 125.102V148.202H385.255V125.102Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 385.255,
    y: 141.643,
    width: 3.68976,
    height: 6.56114,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 408.545,
    y: 141.643,
    width: 3.67834,
    height: 6.56114,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M388.161 140.353L388.161 141.103L389.661 141.103L389.661 140.353L388.161 140.353ZM389.661 124.137C389.661 123.722 389.325 123.387 388.911 123.387C388.497 123.387 388.161 123.722 388.161 124.137L389.661 124.137ZM389.661 140.353L389.661 124.137L388.161 124.137L388.161 140.353L389.661 140.353Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M409.316 124.117C409.316 123.703 408.981 123.367 408.566 123.367C408.152 123.367 407.816 123.703 407.816 124.117L409.316 124.117ZM407.816 140.334L407.816 141.084L409.316 141.084L409.316 140.334L407.816 140.334ZM407.816 124.117L407.816 140.334L409.316 140.334L409.316 124.117L407.816 124.117Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M402.795 115.762C402.795 117.598 401.072 119.243 398.74 119.243C396.408 119.243 394.685 117.598 394.685 115.762C394.685 113.926 396.408 112.281 398.74 112.281C401.072 112.281 402.795 113.926 402.795 115.762Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M411.13 86.0833C409.685 87.1642 408.998 88.884 409 90.5665C409.003 92.2487 409.694 93.9791 411.115 95.0996C413.883 97.2847 415.508 100.152 415.508 103.243C415.508 106.491 413.712 109.495 410.682 111.714C407.653 113.933 403.432 115.329 398.737 115.329C394.043 115.329 389.822 113.933 386.793 111.714C383.763 109.495 381.967 106.491 381.967 103.243C381.967 100.152 383.592 97.2847 386.36 95.0996C389.171 92.886 389.17 88.3112 386.36 86.0953C383.592 83.9102 381.967 81.0427 381.967 77.9523C381.967 74.7042 383.763 71.7002 386.793 69.4807C389.822 67.2615 394.043 65.8662 398.737 65.8662C403.432 65.8662 407.653 67.2615 410.682 69.4807C413.712 71.7002 415.508 74.7042 415.508 77.9523C415.508 81.0539 413.89 84.0194 411.13 86.0833Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.366,
    cy: 104.418,
    r: 1.06214,
    fill: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 406.103,
    cy: 104.418,
    r: 1.06196,
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M395.257 107.848C395.504 108.342 396.472 109.389 398.369 109.626C400.266 109.864 401.729 108.54 402.223 107.848",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 473.526,
    y: 84,
    width: 11.5953,
    height: 24.4111,
    rx: 5.79764,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M488.175 102.308C488.175 107.195 484.213 111.157 479.326 111.157C474.438 111.157 470.477 107.195 470.477 102.308",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 478.96,
    y1: 111,
    x2: 478.96,
    y2: 149,
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M473.477 94.7802H485.224",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M473.477 98.0352H485.224",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 417.122,
    y1: 110.425,
    x2: 423.925,
    y2: 118.971,
    stroke: "black",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 415.405,
    y1: 112.542,
    x2: 421.48,
    y2: 120.173,
    stroke: "black",
    strokeWidth: 1.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.135 137.32C404.584 137.152 406.004 136.59 407.229 135.615C410.719 132.837 411.295 127.756 408.517 124.266C405.739 120.776 400.657 120.199 397.167 122.977C395.943 123.952 395.078 125.21 394.589 126.583C391.615 125.985 388.407 126.655 385.848 128.692C381.244 132.357 380.483 139.06 384.148 143.664C387.814 148.268 394.517 149.029 399.12 145.364C401.679 143.327 403.051 140.352 403.135 137.32Z",
    fill: "#FF90E8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M403.135 137.32L403.049 136.575L402.404 136.65L402.386 137.299L403.135 137.32ZM394.589 126.583L394.442 127.318L395.078 127.446L395.296 126.834L394.589 126.583ZM406.762 135.029C405.65 135.914 404.362 136.423 403.049 136.575L403.222 138.065C404.805 137.882 406.358 137.267 407.696 136.202L406.762 135.029ZM407.93 124.733C410.451 127.899 409.927 132.508 406.762 135.029L407.696 136.202C411.51 133.166 412.14 127.613 409.104 123.799L407.93 124.733ZM397.635 123.564C400.8 121.044 405.41 121.567 407.93 124.733L409.104 123.799C406.067 119.985 400.514 119.354 396.7 122.391L397.635 123.564ZM395.296 126.834C395.739 125.589 396.523 124.449 397.635 123.564L396.7 122.391C395.363 123.455 394.417 124.83 393.883 126.332L395.296 126.834ZM386.315 129.279C388.694 127.385 391.675 126.762 394.442 127.318L394.737 125.848C391.555 125.208 388.12 125.924 385.381 128.105L386.315 129.279ZM384.735 143.197C381.328 138.917 382.035 132.686 386.315 129.279L385.381 128.105C380.453 132.029 379.639 139.204 383.562 144.131L384.735 143.197ZM398.653 144.777C394.374 148.184 388.142 147.477 384.735 143.197L383.562 144.131C387.485 149.059 394.66 149.874 399.588 145.95L398.653 144.777ZM402.386 137.299C402.307 140.119 401.032 142.884 398.653 144.777L399.588 145.95C402.326 143.77 403.794 140.584 403.885 137.341L402.386 137.299Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M415.384 116.468L417.651 119.316L402.925 131.87L399.848 128.006L415.384 116.468Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M417.65 119.319L415.383 116.472L419.95 110.967L424.039 116.102L417.65 119.319Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.578,
    cy: 129.789,
    r: 2.93882,
    transform: "rotate(51.4761 401.578 129.789)",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 389.482,
    y1: 134.466,
    x2: 394.307,
    y2: 140.526,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 211,
    width: 76,
    height: 47,
    rx: 19,
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 419,
    y: 93,
    width: 42,
    height: 26,
    rx: 13,
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 1.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M188.233 232.788C189.521 233.566 189.521 235.434 188.233 236.212L173.034 245.394C171.701 246.2 170 245.24 170 243.682L170 225.318C170 223.76 171.701 222.8 173.034 223.606L188.233 232.788Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M443.455 104.084C444.883 104.962 444.883 107.038 443.455 107.916L439.179 110.548C437.68 111.47 435.75 110.392 435.75 108.631L435.75 103.369C435.75 101.608 437.68 100.53 439.179 101.452L443.455 104.084Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 148,
    x2: 508,
    y2: 148,
    stroke: "black",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 197,
    x2: 508,
    y2: 197,
    stroke: "black",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M386 166C386 165.448 386.448 165 387 165H415.106C415.91 165 416.385 165.9 415.932 166.564L412.264 171.936C412.032 172.276 412.032 172.724 412.264 173.064L415.932 178.436C416.385 179.1 415.91 180 415.106 180H387C386.448 180 386 179.552 386 179V166Z",
    fill: "#FF90E8"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.5,
    cy: 171.5,
    r: 10.5,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1202_18278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 473,
    y: 161,
    width: 21,
    height: 21
  }, _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 483.5,
    cy: 171.5,
    r: 10.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1202_18278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.327 181.722C479.327 179.418 481.195 177.55 483.499 177.55C485.804 177.55 487.672 179.418 487.672 181.722V187.98H479.327V181.722Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.357 185.67L480.357 186.17L481.357 186.17L481.357 185.67L480.357 185.67ZM481.357 180.958C481.357 180.682 481.134 180.458 480.857 180.458C480.581 180.458 480.357 180.682 480.357 180.958L481.357 180.958ZM481.357 185.67L481.357 180.958L480.357 180.958L480.357 185.67L481.357 185.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.781 180.95C486.781 180.674 486.557 180.45 486.281 180.45C486.005 180.45 485.781 180.674 485.781 180.95L486.781 180.95ZM485.781 185.662L485.781 186.162L486.781 186.162L486.781 185.662L485.781 185.662ZM485.781 180.95L485.781 185.662L486.781 185.662L486.781 180.95L485.781 180.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.412 178.499C484.412 178.844 484.072 179.228 483.516 179.228C482.959 179.228 482.619 178.844 482.619 178.499C482.619 178.154 482.959 177.769 483.516 177.769C484.072 177.769 484.412 178.154 484.412 178.499Z",
    fill: "#FF90E8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.937 169.656C485.977 170.412 485.978 171.959 486.937 172.716L486.937 169.656ZM486.937 169.656C487.691 169.061 488.106 168.303 488.106 167.511C488.106 166.679 487.647 165.883 486.819 165.277C485.992 164.671 484.826 164.281 483.515 164.281C482.205 164.281 481.038 164.671 480.211 165.277C479.383 165.883 478.924 166.679 478.924 167.511C478.924 168.304 479.34 169.061 480.093 169.656L486.937 169.656ZM480.093 172.716C479.34 173.31 478.924 174.068 478.924 174.86C478.924 175.693 479.383 176.489 480.211 177.095C481.038 177.7 482.205 178.09 483.515 178.09C484.826 178.09 485.992 177.7 486.819 177.095C487.647 176.489 488.106 175.693 488.106 174.86C488.106 174.068 487.691 173.311 486.937 172.716L480.093 172.716ZM480.093 172.716C481.053 171.959 481.053 170.413 480.093 169.656L480.093 172.716Z",
    fill: "#FF90E8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.373,
    cy: 175.202,
    r: 0.308642,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.655,
    cy: 175.202,
    r: 0.308591,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.503 176.199C482.575 176.343 482.856 176.647 483.407 176.716C483.959 176.785 484.384 176.4 484.527 176.199",
    stroke: "black"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 450,
    width: 220.153,
    height: 254.275,
    rx: 19,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 442,
    width: 220.153,
    height: 254.275,
    rx: 19,
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1202_18278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 441,
    width: 223,
    height: 257
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 442,
    width: 220.153,
    height: 254.275,
    rx: 19,
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1202_18278)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.646,
    y: 442,
    width: 219.83,
    height: 127.372,
    fill: "#23A094"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M479.911 659.504C479.911 658.952 480.359 658.504 480.911 658.504H529.06C529.871 658.504 530.344 659.418 529.877 660.081L522.958 669.889C522.714 670.235 522.714 670.696 522.958 671.042L529.877 680.85C530.344 681.513 529.871 682.427 529.06 682.427H480.911C480.359 682.427 479.911 681.979 479.911 681.427V659.504Z",
    fill: "#FF90E8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M351.104 674.597H352.518L353.54 672.105H358.664L359.672 674.597H361.1L356.998 664.797H355.206L351.104 674.597ZM354.002 670.929L356.102 665.819L358.188 670.929H354.002Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M361.64 671.321C361.64 673.351 362.914 674.737 364.748 674.737C365.756 674.737 366.596 674.205 367.044 673.407V674.597H368.206V664.797H366.988V669.165C366.554 668.339 365.742 667.821 364.72 667.821C362.914 667.821 361.64 669.263 361.64 671.321ZM367.044 671.307C367.044 672.791 365.98 673.659 364.944 673.659C363.852 673.659 362.844 672.805 362.844 671.307C362.844 669.823 363.866 668.913 364.944 668.913C365.98 668.913 367.044 669.837 367.044 671.307Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M369.665 671.321C369.665 673.351 370.939 674.737 372.773 674.737C373.781 674.737 374.621 674.205 375.069 673.407V674.597H376.231V664.797H375.013V669.165C374.579 668.339 373.767 667.821 372.745 667.821C370.939 667.821 369.665 669.263 369.665 671.321ZM375.069 671.307C375.069 672.791 374.005 673.659 372.969 673.659C371.877 673.659 370.869 672.805 370.869 671.307C370.869 669.823 371.891 668.913 372.969 668.913C374.005 668.913 375.069 669.837 375.069 671.307Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M382.228 672.623C382.228 673.953 382.998 674.737 384.398 674.737C385.532 674.737 386.288 674.079 386.47 672.889L385.35 672.637C385.238 673.365 384.916 673.673 384.356 673.673C383.838 673.673 383.446 673.309 383.446 672.679V668.983H385.826V667.961H383.446V665.903H382.228V667.961H380.912V668.983H382.228V672.623Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M387.097 671.279C387.097 673.239 388.455 674.737 390.457 674.737C392.445 674.737 393.831 673.239 393.831 671.279C393.831 669.319 392.473 667.821 390.457 667.821C388.455 667.821 387.097 669.319 387.097 671.279ZM392.585 671.279C392.585 672.679 391.703 673.645 390.457 673.645C389.225 673.645 388.329 672.665 388.329 671.279C388.329 669.893 389.225 668.913 390.457 668.913C391.087 668.913 391.591 669.137 391.983 669.585C392.389 670.019 392.585 670.593 392.585 671.279Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M401.766 673.673C400.59 673.673 399.484 672.721 399.484 671.237C399.484 669.711 400.604 668.885 401.626 668.885C402.704 668.885 403.404 669.501 403.614 670.551L404.72 670.215C404.398 668.703 403.25 667.821 401.64 667.821C399.834 667.821 398.308 669.249 398.308 671.237C398.308 673.337 399.708 674.737 401.794 674.737C403.46 674.737 404.664 673.771 405.042 672.091L403.964 671.685C403.698 672.931 403.054 673.673 401.766 673.673Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M406.103 672.707C406.103 673.323 406.313 673.813 406.733 674.191C407.167 674.555 407.685 674.737 408.301 674.737C409.365 674.737 410.247 674.261 410.583 673.547V674.597H411.745V670.439C411.745 668.801 410.723 667.821 408.917 667.821C407.363 667.821 406.327 668.633 406.061 669.907L407.153 670.215C407.321 669.361 407.965 668.843 408.917 668.843C409.911 668.843 410.583 669.375 410.583 670.341V671.027L409.981 670.859C409.533 670.719 409.057 670.649 408.567 670.649C407.125 670.649 406.103 671.349 406.103 672.707ZM410.583 672.119C410.583 673.085 409.813 673.673 408.707 673.673C407.825 673.673 407.349 673.253 407.349 672.637C407.349 671.951 407.881 671.587 408.735 671.587C409.085 671.587 409.505 671.657 409.967 671.797L410.583 671.979V672.119Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M413.616 667.961V674.597H414.82V670.369C414.82 669.473 415.31 668.885 416.052 668.885C416.71 668.885 417.116 669.263 417.116 669.879C417.116 670.005 417.102 670.173 417.074 670.369H418.25C418.306 670.145 418.334 669.893 418.334 669.627C418.334 668.619 417.592 667.821 416.514 667.821C415.716 667.821 415.114 668.213 414.82 668.927V667.961H413.616Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M420.482 672.623C420.482 673.953 421.252 674.737 422.652 674.737C423.786 674.737 424.542 674.079 424.724 672.889L423.604 672.637C423.492 673.365 423.17 673.673 422.61 673.673C422.092 673.673 421.7 673.309 421.7 672.679V668.983H424.08V667.961H421.7V665.903H420.482V667.961H419.166V668.983H420.482V672.623Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M494.716 675.725C495.772 675.613 496.62 675.277 497.26 674.685C497.916 674.093 498.236 673.341 498.236 672.445C498.236 670.797 497.148 669.789 494.716 669.325V665.677C495.644 665.917 496.268 666.557 496.572 667.597L497.868 666.893C497.356 665.437 496.204 664.541 494.716 664.301V662.829H493.388V664.269C491.452 664.461 490.188 665.757 490.188 667.213C490.188 668.861 491.26 669.949 493.388 670.445V674.349C491.996 674.109 491.068 673.197 490.604 671.581L489.292 672.301C489.932 674.365 491.516 675.469 493.388 675.709V677.165H494.716V675.725ZM493.388 669.037C492.22 668.669 491.612 668.141 491.612 667.197C491.612 666.349 492.3 665.725 493.388 665.613V669.037ZM496.812 672.573C496.812 673.533 496.044 674.237 494.716 674.381V670.717C496.252 671.085 496.812 671.629 496.812 672.573Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M502.173 675.597H503.565V664.397H502.333C501.949 665.933 500.797 666.845 499.149 667.021L499.421 668.445C499.981 668.397 500.509 668.205 501.037 667.869C501.565 667.533 501.949 667.101 502.173 666.589V675.597Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M513.149 664.397H506.125C506.125 666.301 505.965 668.317 505.645 670.413L507.117 670.749C507.501 669.917 508.541 669.261 509.645 669.261C511.357 669.261 512.269 670.317 512.269 671.837C512.269 673.357 511.277 674.461 509.549 674.461C508.013 674.461 507.101 673.597 506.861 672.077L505.517 672.461C505.661 673.517 506.093 674.333 506.845 674.909C507.597 675.469 508.493 675.757 509.549 675.757C512.077 675.757 513.661 674.061 513.661 671.677C513.661 669.373 512.029 668.013 509.965 668.013C508.733 668.013 507.677 668.541 507.021 669.293C507.293 667.933 507.421 666.733 507.421 665.693H513.149V664.397Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M364.175 532.234C364.175 525.606 369.547 520.234 376.175 520.234H390.968C397.596 520.234 402.968 525.606 402.968 532.234V568.725H364.175V532.234Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 364.175,
    y: 557.734,
    width: 7.11214,
    height: 10.9915,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 396.882,
    y: 559.596,
    width: 4.99568,
    height: 8.89019,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M370.286 557.986L370.286 558.986L372.286 558.986L372.286 557.986L370.286 557.986ZM372.286 536.078C372.286 535.525 371.838 535.078 371.286 535.078C370.734 535.078 370.286 535.525 370.286 536.078L372.286 536.078ZM372.286 557.986L372.286 536.078L370.286 536.078L370.286 557.986L372.286 557.986Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M397.502 536.041C397.502 535.488 397.054 535.041 396.502 535.041C395.95 535.041 395.502 535.488 395.502 536.041L397.502 536.041ZM395.502 557.949L395.502 558.949L397.502 558.949L397.502 557.949L395.502 557.949ZM395.502 536.041L395.502 557.949L397.502 557.949L397.502 536.041L395.502 536.041Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M389.39 524.647C389.39 527.303 386.912 529.613 383.648 529.613C380.384 529.613 377.906 527.303 377.906 524.647C377.906 521.991 380.384 519.68 383.648 519.68C386.912 519.68 389.39 521.991 389.39 524.647Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 1.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M406.314 473.565C406.314 477.745 404.115 481.622 400.373 484.576L400.373 484.576C396.583 487.561 396.584 493.732 400.373 496.72C404.115 499.674 406.314 503.551 406.314 507.731C406.314 512.124 403.885 516.186 399.789 519.186C395.694 522.186 389.989 524.072 383.644 524.072C377.3 524.072 371.595 522.186 367.499 519.186C363.404 516.186 360.975 512.124 360.975 507.731C360.975 503.552 363.173 499.674 366.914 496.721C370.705 493.736 370.704 487.565 366.915 484.576C363.173 481.623 360.975 477.745 360.975 473.565C360.975 469.172 363.404 465.11 367.499 462.11C371.595 459.11 377.3 457.224 383.644 457.224C389.989 457.224 395.694 459.11 399.789 462.11C403.885 465.11 406.314 469.172 406.314 473.565Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.686,
    cy: 509.318,
    r: 1.43489,
    fill: "black"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.595,
    cy: 509.317,
    r: 1.43466,
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M378.939 513.954C379.273 514.622 380.581 516.037 383.144 516.357C385.707 516.677 387.682 514.889 388.35 513.954",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 484.463,
    y: 486.396,
    width: 16.0757,
    height: 33.8435,
    rx: 8.03783,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M504.771 511.777C504.771 518.553 499.278 524.045 492.503 524.045C485.727 524.045 480.234 518.553 480.234 511.777",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 492.718,
    y1: 524.48,
    x2: 492.718,
    y2: 569.322,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M484.463 501.34H500.75",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M484.463 505.852H500.75",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M351.958 595.312V601.372H353.798V587.372H351.958V593.632H343.938V587.372H342.098V601.372H343.938V595.312H351.958Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M356.084 596.632C356.084 599.432 358.024 601.572 360.884 601.572C363.724 601.572 365.704 599.432 365.704 596.632C365.704 593.832 363.764 591.692 360.884 591.692C358.024 591.692 356.084 593.832 356.084 596.632ZM363.924 596.632C363.924 598.632 362.664 600.012 360.884 600.012C359.124 600.012 357.844 598.612 357.844 596.632C357.844 594.652 359.124 593.252 360.884 593.252C361.784 593.252 362.504 593.572 363.064 594.212C363.644 594.832 363.924 595.652 363.924 596.632Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M368.301 591.892H366.601L369.421 601.372H371.581L373.681 594.092L375.781 601.372H377.921L380.741 591.892H379.041L376.821 599.692L374.681 591.892H372.661L370.521 599.692L368.301 591.892Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M388.328 598.552C388.328 600.452 389.428 601.572 391.428 601.572C393.048 601.572 394.128 600.632 394.388 598.932L392.788 598.572C392.628 599.612 392.168 600.052 391.368 600.052C390.628 600.052 390.068 599.532 390.068 598.632V593.352H393.468V591.892H390.068V588.952H388.328V591.892H386.448V593.352H388.328V598.552Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M395.283 596.632C395.283 599.432 397.223 601.572 400.083 601.572C402.923 601.572 404.903 599.432 404.903 596.632C404.903 593.832 402.963 591.692 400.083 591.692C397.223 591.692 395.283 593.832 395.283 596.632ZM403.123 596.632C403.123 598.632 401.863 600.012 400.083 600.012C398.323 600.012 397.043 598.612 397.043 596.632C397.043 594.652 398.323 593.252 400.083 593.252C400.983 593.252 401.703 593.572 402.263 594.212C402.843 594.832 403.123 595.652 403.123 596.632Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M413.899 595.612H418.239C421.059 595.612 422.779 593.712 422.779 591.492C422.779 589.212 421.139 587.372 418.239 587.372H412.059V601.372H413.899V595.612ZM413.899 593.872V589.112H418.079C419.739 589.112 420.839 589.972 420.839 591.492C420.839 593.012 419.739 593.872 418.079 593.872H413.899Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M425.043 601.372H426.763V587.372H425.043V601.372Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M428.997 598.672C428.997 599.552 429.297 600.252 429.897 600.792C430.517 601.312 431.257 601.572 432.137 601.572C433.657 601.572 434.917 600.892 435.397 599.872V601.372H437.057V595.432C437.057 593.092 435.597 591.692 433.017 591.692C430.797 591.692 429.317 592.852 428.937 594.672L430.497 595.112C430.737 593.892 431.657 593.152 433.017 593.152C434.437 593.152 435.397 593.912 435.397 595.292V596.272L434.537 596.032C433.897 595.832 433.217 595.732 432.517 595.732C430.457 595.732 428.997 596.732 428.997 598.672ZM435.397 597.832C435.397 599.212 434.297 600.052 432.717 600.052C431.457 600.052 430.777 599.452 430.777 598.572C430.777 597.592 431.537 597.072 432.757 597.072C433.257 597.072 433.857 597.172 434.517 597.372L435.397 597.632V597.832Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M445.52 591.892L442.7 598.132L440.04 591.892H438.16L441.78 600.152L439.44 605.332H441.28L447.36 591.892H445.52Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M453.911 587.372V595.772C453.911 599.152 456.111 601.572 459.671 601.572C463.231 601.572 465.451 599.152 465.451 595.772V587.372H463.611V595.592C463.611 598.292 462.131 599.832 459.671 599.832C457.251 599.832 455.751 598.292 455.751 595.592V587.372H453.911Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M472.548 595.732L476.148 591.892H473.948L469.888 596.332V587.372H468.168V601.372H469.888V598.552L471.348 597.012L474.348 601.372H476.448L472.548 595.732Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M484.678 597.932C484.298 599.292 483.398 600.052 481.938 600.052C480.258 600.052 478.938 598.952 478.918 596.892H485.778C485.858 596.532 485.898 596.152 485.898 595.732C485.898 594.492 485.518 593.512 484.738 592.792C483.958 592.052 482.938 591.692 481.678 591.692C478.978 591.692 477.158 593.852 477.158 596.572C477.158 599.632 479.158 601.572 481.938 601.572C484.118 601.572 485.538 600.432 486.178 598.512L484.678 597.932ZM478.918 595.652C479.098 594.152 480.198 593.212 481.658 593.212C483.098 593.212 484.198 594.012 484.198 595.372L484.178 595.652H478.918Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M488.187 601.372H489.907V587.372H488.187V601.372Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M499.522 597.932C499.142 599.292 498.242 600.052 496.782 600.052C495.102 600.052 493.782 598.952 493.762 596.892H500.622C500.702 596.532 500.742 596.152 500.742 595.732C500.742 594.492 500.362 593.512 499.582 592.792C498.802 592.052 497.782 591.692 496.522 591.692C493.822 591.692 492.002 593.852 492.002 596.572C492.002 599.632 494.002 601.572 496.782 601.572C498.962 601.572 500.382 600.432 501.022 598.512L499.522 597.932ZM493.762 595.652C493.942 594.152 495.042 593.212 496.502 593.212C497.942 593.212 499.042 594.012 499.042 595.372L499.022 595.652H493.762Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M503.031 601.372H504.751V587.372H503.031V601.372Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M514.365 597.932C513.985 599.292 513.085 600.052 511.625 600.052C509.945 600.052 508.625 598.952 508.605 596.892H515.465C515.545 596.532 515.585 596.152 515.585 595.732C515.585 594.492 515.205 593.512 514.425 592.792C513.645 592.052 512.625 591.692 511.365 591.692C508.665 591.692 506.845 593.852 506.845 596.572C506.845 599.632 508.845 601.572 511.625 601.572C513.805 601.572 515.225 600.432 515.865 598.512L514.365 597.932ZM508.605 595.652C508.785 594.152 509.885 593.212 511.345 593.212C512.785 593.212 513.885 594.012 513.885 595.372L513.865 595.652H508.605Z",
    fill: "black"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 407.301,
    y1: 521.032,
    x2: 415.979,
    y2: 531.932,
    stroke: "black",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 405.111,
    y1: 523.732,
    x2: 412.86,
    y2: 533.465,
    stroke: "black",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.426 555.364C391.273 555.15 393.085 554.433 394.647 553.189C399.099 549.645 399.834 543.164 396.29 538.712C392.746 534.26 386.265 533.525 381.813 537.069C380.252 538.312 379.147 539.916 378.525 541.668C374.731 540.905 370.639 541.759 367.374 544.358C361.502 549.033 360.531 557.584 365.206 563.456C369.882 569.329 378.432 570.299 384.304 565.624C387.568 563.026 389.318 559.231 389.426 555.364Z",
    fill: "#FF90E8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M389.426 555.364L389.311 554.37L388.45 554.47L388.426 555.336L389.426 555.364ZM378.525 541.668L378.328 542.648L379.177 542.819L379.467 542.003L378.525 541.668ZM394.024 552.407C392.613 553.531 390.978 554.177 389.311 554.37L389.541 556.357C391.568 556.122 393.557 555.335 395.27 553.972L394.024 552.407ZM395.508 539.335C398.708 543.354 398.044 549.207 394.024 552.407L395.27 553.972C400.154 550.084 400.961 542.973 397.073 538.089L395.508 539.335ZM382.436 537.851C386.455 534.651 392.308 535.315 395.508 539.335L397.073 538.089C393.185 533.206 386.074 532.398 381.19 536.286L382.436 537.851ZM379.467 542.003C380.029 540.422 381.025 538.974 382.436 537.851L381.19 536.286C379.479 537.649 378.266 539.41 377.583 541.333L379.467 542.003ZM367.997 545.141C371.021 542.733 374.811 541.941 378.328 542.648L378.722 540.687C374.651 539.869 370.256 540.786 366.751 543.576L367.997 545.141ZM365.989 562.833C361.658 557.393 362.557 549.472 367.997 545.141L366.751 543.576C360.447 548.595 359.405 557.775 364.424 564.079L365.989 562.833ZM383.682 564.842C378.241 569.173 370.32 568.274 365.989 562.833L364.424 564.079C369.443 570.383 378.623 571.425 384.927 566.406L383.682 564.842ZM388.426 555.336C388.326 558.921 386.705 562.435 383.682 564.842L384.927 566.406C388.431 563.617 390.309 559.541 390.425 555.392L388.426 555.336Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M405.049 528.765L407.941 532.398L389.156 548.412L385.232 543.483L405.049 528.765Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M407.94 532.403L405.048 528.77L410.875 521.748L416.089 528.299L407.94 532.403Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.438,
    cy: 545.758,
    r: 3.74869,
    transform: "rotate(51.4761 387.438 545.758)",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 372.043,
    y1: 551.696,
    x2: 378.197,
    y2: 559.427,
    stroke: "black",
    strokeWidth: 2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.276,
    cy: 625.299,
    r: 9.37509,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1202_18278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 340,
    y: 615,
    width: 20,
    height: 20
  }, _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.276,
    cy: 625.299,
    r: 9.37509,
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1202_18278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.551 634.426C346.551 632.369 348.219 630.701 350.276 630.701C352.333 630.701 354.001 632.369 354.001 634.426V640.014H346.551V634.426Z",
    fill: "#F1F333",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.417 637.951L347.417 638.451L348.417 638.451L348.417 637.951L347.417 637.951ZM348.417 633.744C348.417 633.467 348.193 633.244 347.917 633.244C347.641 633.244 347.417 633.467 347.417 633.744L348.417 633.744ZM348.417 637.951L348.417 633.744L347.417 633.744L347.417 637.951L348.417 637.951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.26 633.736C353.26 633.46 353.036 633.236 352.76 633.236C352.484 633.236 352.26 633.46 352.26 633.736L353.26 633.736ZM352.26 637.944L352.26 638.444L353.26 638.444L353.26 637.944L352.26 637.944ZM352.26 633.736L352.26 637.944L353.26 637.944L353.26 633.736L352.26 633.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.038 631.548C351.038 631.821 350.765 632.146 350.291 632.146C349.817 632.146 349.544 631.821 349.544 631.548C349.544 631.276 349.817 630.95 350.291 630.95C350.765 630.95 351.038 631.276 351.038 631.548Z",
    fill: "#FF90E8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.312 623.611C352.428 624.307 352.428 625.729 353.312 626.427L353.312 623.611ZM353.312 623.611C353.975 623.087 354.336 622.425 354.336 621.738C354.336 621.016 353.937 620.32 353.209 619.786C352.48 619.253 351.45 618.908 350.29 618.908C349.13 618.908 348.1 619.253 347.371 619.786C346.643 620.32 346.244 621.016 346.244 621.738C346.244 622.425 346.605 623.087 347.268 623.611L353.312 623.611ZM347.267 626.427C346.604 626.95 346.244 627.613 346.244 628.3C346.244 629.021 346.643 629.717 347.371 630.251C348.1 630.785 349.13 631.13 350.29 631.13C351.45 631.13 352.48 630.785 353.209 630.251C353.937 629.717 354.336 629.021 354.336 628.3C354.336 627.612 353.975 626.95 353.312 626.427L347.267 626.427ZM347.267 626.427C348.152 625.73 348.152 624.308 347.268 623.611L347.267 626.427Z",
    fill: "#FF90E8",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.377,
    cy: 628.604,
    r: 0.275576,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.2,
    cy: 628.604,
    r: 0.275531,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.387 629.495C349.451 629.623 349.702 629.895 350.194 629.956C350.686 630.018 351.066 629.674 351.194 629.495",
    stroke: "black"
  }))), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 327.323,
    y1: 643.926,
    x2: 547.153,
    y2: 643.926,
    stroke: "black",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 460.867,
    y1: 644.926,
    x2: 460.867,
    y2: 696.004,
    stroke: "black",
    strokeWidth: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 442,
    width: 220.153,
    height: 254.275,
    rx: 19,
    stroke: "black",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 327.323,
    y1: 568.372,
    x2: 547.153,
    y2: 568.372,
    stroke: "black",
    strokeWidth: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 416.225,
    y: 495.018,
    width: 50.4315,
    height: 31.6813,
    rx: 15.8407,
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M446.164 509.128C447.492 509.899 447.492 511.818 446.164 512.588L438.979 516.755C437.646 517.529 435.976 516.567 435.976 515.025L435.976 506.691C435.976 505.15 437.646 504.188 438.979 504.961L446.164 509.128Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M371.291 624.979H374.731C377.051 624.979 378.331 623.363 378.331 621.619C378.331 619.811 377.067 618.259 374.731 618.259H369.531V629.459H371.291V624.979ZM371.291 623.299V619.939H374.571C375.707 619.939 376.491 620.595 376.491 621.619C376.491 622.643 375.707 623.299 374.571 623.299H371.291Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M380.112 621.875V629.459H381.792V624.419C381.792 623.635 382.272 623.155 382.992 623.155C383.632 623.155 384.112 623.587 384.112 624.179C384.112 624.387 384.096 624.611 384.048 624.819H385.712C385.792 624.515 385.824 624.195 385.824 623.859C385.824 623.251 385.616 622.739 385.2 622.339C384.784 621.923 384.256 621.715 383.632 621.715C382.736 621.715 382.096 622.163 381.792 622.979V621.875H380.112Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M387.633 621.875V629.459H389.313V621.875H387.633ZM387.553 620.579H389.393V618.739H387.553V620.579Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M396.776 621.875L394.568 626.515L392.504 621.875H390.696L393.688 628.339L391.656 632.627H393.416L398.536 621.875H396.776Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M399.622 627.299C399.622 628.755 400.87 629.619 402.118 629.619C403.462 629.619 404.326 629.027 404.662 628.179V629.459H406.262V624.739C406.262 622.819 405.062 621.715 402.902 621.715C401.046 621.715 399.878 622.691 399.542 624.179L401.062 624.579C401.238 623.667 401.894 623.075 402.902 623.075C403.91 623.075 404.662 623.651 404.662 624.659V625.219L403.862 625.027C403.43 624.915 402.982 624.867 402.518 624.867C400.838 624.867 399.622 625.651 399.622 627.299ZM404.662 626.579C404.662 627.587 403.894 628.179 402.79 628.179C401.83 628.179 401.382 627.731 401.382 627.139C401.382 626.451 401.942 626.131 402.79 626.131C403.094 626.131 403.51 626.195 404.054 626.339L404.662 626.499V626.579Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M410.236 629.459V625.235C410.236 623.939 411.004 623.155 412.028 623.155C412.988 623.155 413.596 623.859 413.596 625.075V629.459H415.276V624.499C415.276 622.771 414.204 621.715 412.62 621.715C411.612 621.715 410.764 622.099 410.236 622.979V621.875H408.556V629.459H410.236Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M421.338 624.979L424.282 621.875H422.122L419.242 625.059V618.259H417.562V629.459H419.242V627.187L420.186 626.195L422.442 629.459H424.442L421.338 624.979Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M425.498 627.299C425.498 628.755 426.746 629.619 427.994 629.619C429.338 629.619 430.202 629.027 430.538 628.179V629.459H432.138V624.739C432.138 622.819 430.938 621.715 428.778 621.715C426.922 621.715 425.754 622.691 425.418 624.179L426.938 624.579C427.114 623.667 427.77 623.075 428.778 623.075C429.786 623.075 430.538 623.651 430.538 624.659V625.219L429.738 625.027C429.306 624.915 428.858 624.867 428.394 624.867C426.714 624.867 425.498 625.651 425.498 627.299ZM430.538 626.579C430.538 627.587 429.77 628.179 428.666 628.179C427.706 628.179 427.258 627.731 427.258 627.139C427.258 626.451 427.818 626.131 428.666 626.131C428.97 626.131 429.386 626.195 429.93 626.339L430.538 626.499V626.579Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M242.217 500.266C261.123 547.793 239.943 600.743 195.056 618.6C150.17 636.456 98.4047 612.525 79.4979 564.998C60.591 517.471 81.7717 464.521 126.658 446.665C171.545 428.808 223.31 452.739 242.217 500.266Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M167.359 612.961C157.522 587.53 124.7 505.025 110.955 471.183L133.147 462.354L137.377 472.988C134.871 473.858 132.862 474.589 131.172 475.208C130.894 475.31 130.626 475.408 130.366 475.504C128.832 476.066 127.58 476.526 126.432 476.915L125.435 477.253L125.824 478.232C126.921 480.987 129.864 488.474 132.878 496.14L133.093 496.688C136.18 504.539 139.296 512.463 140.529 515.565L140.911 516.523L141.857 516.113C143.691 515.316 145.656 514.495 147.433 513.753C149.181 513.023 150.747 512.369 151.826 511.889L156.194 522.867C153.877 523.654 149.673 525.211 145.894 526.714L144.972 527.081L145.332 528.006C151.619 544.178 166.64 581.937 173.016 597.595L173.39 598.514L174.311 598.147C177.741 596.783 181.672 595.081 185.857 593.011L190.182 603.881L167.359 612.961ZM202.195 585.075C204.734 584.065 207.533 582.82 210.5 581.379L215.445 593.807C209.838 595.893 202.918 598.523 195.668 601.663C186.573 577.427 147.657 480.286 139.27 459.918L149.789 455.734C157.049 475.021 188.011 552.489 200.897 584.519L201.269 585.443L202.195 585.075ZM178.594 459.38C185.447 477.643 204.31 524.697 217.19 556.711L217.561 557.635L218.487 557.267C221.026 556.257 223.826 555.012 226.793 553.57L230.838 563.738C225.231 565.825 218.311 568.454 211.061 571.594C202.317 548.241 176.066 482.936 168.076 463.564L178.594 459.38ZM102.536 506.483C103.493 508.889 106.435 513.927 110.31 520.236C113.47 525.381 117.294 531.439 121.267 537.734C122.197 539.206 123.134 540.691 124.073 542.18C129.031 550.044 134.035 558.031 138.135 564.894C142.25 571.781 145.409 577.465 146.717 580.753C148.818 586.034 148.924 590.41 147.642 593.799C146.366 597.176 143.655 599.722 139.815 601.249C136.563 602.543 132.978 603.052 129.576 602.925L128.165 591.783C130.191 592.274 132.037 592.136 133.47 591.566C134.862 591.012 135.942 589.944 136.468 588.522C136.993 587.104 136.939 585.417 136.235 583.646C134.953 580.424 131.839 574.867 127.872 568.235C123.891 561.577 119.004 553.759 114.136 545.982L113.554 545.052C108.88 537.585 104.258 530.201 100.492 523.942C96.5533 517.396 93.6029 512.164 92.4883 509.363C90.7244 504.929 90.6321 500.894 91.8518 497.635C93.0674 494.386 95.6248 491.8 99.3772 490.307C103.102 488.826 106.662 488.662 109.529 489.008L109.384 499.679C107.761 499.365 105.942 499.424 104.545 499.98C103.32 500.468 102.48 501.385 102.144 502.598C101.819 503.771 101.992 505.115 102.536 506.483Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlauUkulele);
export default __webpack_public_path__ + "static/media/plauUkulele.6641892ab5dfb4716bb7beadf87f7ef9.svg";
export { ForwardRef as ReactComponent };